
import { Component, Vue, Prop, Mixins } from 'vue-property-decorator';
import { PaymentMethodModel } from '@/models/stripe/PaymentMethodModel';
import {BAIconsMixin, VuetifyMixin} from '@/mixins';

@Component
export default class PaymentMethodIcon extends Mixins(BAIconsMixin, VuetifyMixin){
	@Prop({ default: 32 }) height: number;
	@Prop({ default: null }) brand: string | null;
	@Prop({ default: null }) paymentMethod: PaymentMethodModel | null;
	@Prop({ type: Boolean, default: false }) mastercard: boolean;
	get IsVisa(): boolean{
		if(this.brand !== null) return this.brand === 'visa';
		if(this.paymentMethod === null) return false;
		if(!this.paymentMethod.stripePaymentMethodDetails) return false;
		if(!this.paymentMethod.stripePaymentMethodDetails.card) return false;
		if(this.paymentMethod.stripePaymentMethodDetails.card.brand === 'visa') return true;
		return false;
	}
	get IsMastercard(): boolean{
		if(this.brand !== null) return this.brand === 'mastercard';
		if(this.paymentMethod === null) return false;
		if(!this.paymentMethod.stripePaymentMethodDetails) return false;
		if(!this.paymentMethod.stripePaymentMethodDetails.card) return false;
		if(this.paymentMethod.stripePaymentMethodDetails.card.brand === 'mastercard') return true;
		return false;
	}
	get AspectRatio(): number{
		return 48/32;
	}
}
